import { atom } from "recoil";

export const confirmDeleteState = atom<{ onOk?: () => void; show: boolean } | undefined>({
  key: "confirmDeleteState",
  default: undefined,
});
